/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BooleanResponse } from "../models/BooleanResponse";
import type { CreateOrganizationRequest } from "../models/CreateOrganizationRequest";
import type { GrantOrganizationRoleRequest } from "../models/GrantOrganizationRoleRequest";
import type { OrganizationRoleRequest } from "../models/OrganizationRoleRequest";
import type { Response_list_definitions_public_v1_organization_Organization__ } from "../models/Response_list_definitions_public_v1_organization_Organization__";
import type { Response_Organization_ } from "../models/Response_Organization_";
import type { Response_UUID_ } from "../models/Response_UUID_";
import type { SubscriptionTier } from "../models/SubscriptionTier";
import type { UpdateOrganizationRequest } from "../models/UpdateOrganizationRequest";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class OrganizationsService {
  /**
   * List Organizations
   * @param qs Search query for organization names
   * @param tiers List of subscription tiers to filter organizations by
   * @returns Response_list_definitions_public_v1_organization_Organization__ Successful Response
   * @throws ApiError
   */
  public static organizationsListOrganizations(
    qs?: string,
    tiers?: Array<SubscriptionTier>
  ): CancelablePromise<Response_list_definitions_public_v1_organization_Organization__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/organizations",
      query: {
        qs: qs,
        tiers: tiers,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Organization
   * @param requestBody
   * @returns Response_UUID_ Successful Response
   * @throws ApiError
   */
  public static organizationsCreateOrganization(
    requestBody: CreateOrganizationRequest
  ): CancelablePromise<Response_UUID_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/organizations",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Organization
   * @param organizationId
   * @returns Response_Organization_ Successful Response
   * @throws ApiError
   */
  public static organizationsGetOrganization(
    organizationId: string
  ): CancelablePromise<Response_Organization_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/organizations/{organization_id}",
      path: {
        organization_id: organizationId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Organization
   * @param organizationId
   * @param requestBody
   * @returns Response_UUID_ Successful Response
   * @throws ApiError
   */
  public static organizationsUpdateOrganization(
    organizationId: string,
    requestBody: UpdateOrganizationRequest
  ): CancelablePromise<Response_UUID_> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/organizations/{organization_id}",
      path: {
        organization_id: organizationId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Organization Role
   * @param organizationId
   * @param requestBody
   * @returns Response_UUID_ Successful Response
   * @throws ApiError
   */
  public static organizationsCreateOrganizationRole(
    organizationId: string,
    requestBody: OrganizationRoleRequest
  ): CancelablePromise<Response_UUID_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/organizations/{organization_id}/roles",
      path: {
        organization_id: organizationId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Organization Role
   * @param organizationId
   * @param roleId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationsUpdateOrganizationRole(
    organizationId: string,
    roleId: string,
    requestBody: OrganizationRoleRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/organizations/{organization_id}/roles/{role_id}",
      path: {
        organization_id: organizationId,
        role_id: roleId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Grant Organization Role To User
   * @param organizationId
   * @param userId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationsGrantOrganizationRoleToUser(
    organizationId: string,
    userId: string,
    requestBody: GrantOrganizationRoleRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/organizations/{organization_id}/user/{user_id}/roles",
      path: {
        organization_id: organizationId,
        user_id: userId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Revoke Organization Role From User
   * @param organizationId
   * @param userId
   * @param roleId
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationsRevokeOrganizationRoleFromUser(
    organizationId: string,
    userId: string,
    roleId: string
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/organizations/{organization_id}/user/{user_id}/roles/{role_id}",
      path: {
        organization_id: organizationId,
        user_id: userId,
        role_id: roleId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
